import React from 'react';
import { Link } from 'react-router-dom';
import { useFetchSubscriptions } from '../hooks/DataFetching/useFetchSubscriptions';

export const FetchSubscriptions = () => {
  const { subscriptions, loading } = useFetchSubscriptions();

  const renderSubscriptionsTable = (subscriptions) => {
    return (
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Group Name</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map(subscription => (
            <tr key={subscription.id}>
              <td>
                <Link to={`/group-members/${subscription.groupId}`}>{subscription.groupName}</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const contents = loading
    ? <p><em>Loading...</em></p>
    : renderSubscriptionsTable(subscriptions);

  return (
    <div>
      <h1 id="tabelLabel">Subscriptions</h1>
      {contents}
    </div>
  );
};
